
export interface QuizAttempt {
  id: string;
  userId: string;
  quizId: string;
  score: number;
  total: number;
  passed: boolean;
  timestamp: string;
}

export const storageService = {
  saveProgress: async (userId: string, slug: string, progress: any) => {
    // Simuloi Supabase-kutsua
    console.log(`[Supabase] Saving progress for ${userId}/${slug}`);
    const key = `lail-progress-${userId}-${slug}`;
    localStorage.setItem(key, JSON.stringify(progress));
    return { success: true };
  },

  saveQuizAttempt: async (attempt: QuizAttempt) => {
    console.log(`[Supabase] Saving attempt for ${attempt.userId}/${attempt.quizId}`);
    const attempts = JSON.parse(localStorage.getItem('lail-attempts') || '[]');
    attempts.push(attempt);
    localStorage.setItem('lail-attempts', JSON.stringify(attempts));
    return { success: true };
  },

  getAttempts: async (userId: string) => {
    const attempts = JSON.parse(localStorage.getItem('lail-attempts') || '[]');
    return attempts.filter((a: any) => a.userId === userId);
  }
};
